import { uniq, compact } from 'lodash'
import Tag from '../tags/Tag'
import type { ActivityJson } from 'app/types/entities'
import type { PersonSummary } from 'app/types/entities'
import { removePatientType } from 'lib/removePatientType'

export const PersonOutcomes = ({
  activity,
  person,
  personIndex,
  workspaceId,
}: {
  activity?: ActivityJson
  person: PersonSummary
  personIndex: number
  workspaceId?: string
}) => {
  //TRK-2883: If the person index is NOT in activity.contacts block, then no matched contact
  const matchedContact = activity?.contacts?.find((contact) => contact.peopleIndex === personIndex)
  const outcomes = uniq(
    compact([
      ...(!matchedContact && person.patientType === `Current Patient` ? [`No Patient Found`] : []),
      ...(removePatientType(person.outcomes) || []),
    ]),
  ).flatMap((outcome) => outcome.split(`,`))
  return (
    <div className="flex flex-wrap gap-2">
      {outcomes?.map((outcome, i) => (
        <Tag
          key={`${outcome}-${i}`}
          workspaceId={workspaceId}
          model="activities"
          tag={outcome as string}
          removeTag={() => {}}
          tagClassName="text-body-xs leading-4"
          readOnly
        />
      ))}
    </div>
  )
}
